import { forwardRef } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MaintenanceTypeApi } from '@api/maintenanceType.api';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { debounceTime } from 'rxjs/operators';
import english from '../../../../../main/maintenances/i18n/en.json';
import spanish from '../../../../../main/maintenances/i18n/es.json';
import portuguese from '../../../../../main/maintenances/i18n/pt.json';
var INPUT_FIELD_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return MaintenanceTypeLegacyComponent; }),
    multi: true
};
var MaintenanceTypeLegacyComponent = /** @class */ (function () {
    function MaintenanceTypeLegacyComponent(fuseTranslationLoaderService, maintenanceTypeApi) {
        var _this = this;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.maintenanceTypeApi = maintenanceTypeApi;
        this.maintenancesTypes = [];
        this.inputValue = new FormControl();
        this.loading = false;
        this.onChange = function () { };
        this.onTouched = function () { };
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.inputValue.valueChanges
            .pipe(debounceTime(500))
            .subscribe(function (value) {
            _this.maintenancesTypes = [];
            if (value) {
                _this.searchMaintenancesTypes({ name_contains: value });
            }
        });
    }
    MaintenanceTypeLegacyComponent.prototype.searchMaintenancesTypes = function (query) {
        var _this = this;
        var orderBy = {
            orderColumn: 'name',
            order: 'asc',
        };
        this.loading = true;
        this.maintenanceTypeApi.search(query, orderBy).subscribe(function (result) {
            _this.loading = false;
            _this.maintenancesTypes = result.items;
        });
    };
    MaintenanceTypeLegacyComponent.prototype.writeValue = function (maintenanceTypeId) {
        var _this = this;
        if (!maintenanceTypeId) {
            return this.deselectMaintenanceType();
        }
        this.maintenanceTypeApi.searchOne(maintenanceTypeId).then(function (maintenanceType) {
            _this.selectedMaintenanceType = maintenanceType;
            _this.hasSelectedMaintenanceType = true;
            _this.inputValue.setErrors(null);
        });
    };
    MaintenanceTypeLegacyComponent.prototype.setSelectedMaintenanceType = function () {
        var value = this.inputValue.value;
        if (value) {
            this.onChange(value);
            this.selectedMaintenanceType = this.maintenancesTypes
                .find(function (maintenanceType) { return maintenanceType.id === value; });
            this.hasSelectedMaintenanceType = true;
            this.inputValue.setErrors(null);
        }
    };
    MaintenanceTypeLegacyComponent.prototype.deselectMaintenanceType = function () {
        this.onChange(null);
        this.selectedMaintenanceType = null;
        this.hasSelectedMaintenanceType = false;
        this.inputValue.setValue(null);
        this.inputValue.setErrors(null);
    };
    MaintenanceTypeLegacyComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    MaintenanceTypeLegacyComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    return MaintenanceTypeLegacyComponent;
}());
export { MaintenanceTypeLegacyComponent };
